import { render, staticRenderFns } from "./DocumentViewHeader.vue?vue&type=template&id=24a952cb&scoped=true"
import script from "./DocumentViewHeader.vue?vue&type=script&lang=js"
export * from "./DocumentViewHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewHeader.vue?vue&type=style&index=0&id=24a952cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a952cb",
  null
  
)

export default component.exports